// PathName is used to match route path. It should be uniq.
// name is used to display menu item name and set as kind black list, so it should be uniq too
export default [
  {
    name: '首页',
    pathName: 'dashboard',
    icon: 'el-icon-s-home'
  },
  {
    name: '订单列表',
    icon: 'el-icon-s-order',
    needcan: '订单管理',
    children: [
      {
        name: '全部订单',
        pathName: 'order-list'
      },
      {
        name: '退款维权',
        pathName: 'order-refund'
      }
    ]
  },
  {
    name: '商品信息',
    icon: 'el-icon-s-goods',
    needcan: '商品管理',
    children: [
      {
        name: '商品管理',
        pathName: 'products-list'
      },
      {
        name: '类目管理',
        pathName: 'category-list'
      }
    ]
  },
  {
    name: '开课报名',
    icon: 'el-icon-s-goods',
    needcan: '报名管理',
    children: [
      {
        name: '课程列表',
        pathName: 'course-list'
      },
      {
        name: '报名记录',
        pathName: 'course-records'
      }
    ]
  },
  {
    name: '预约管理',
    icon: 'el-icon-s-custom',
    pathName: 'reservation-list',
    needcan: '预约管理'
  },
  {
    name: '名师名生',
    icon: 'el-icon-s-goods',
    needcan: '名师名生管理',
    children: [
      {
        name: '明星老师',
        pathName: 'setting-teacher'
      },
      {
        name: '明星学员',
        pathName: 'setting-student'
      }
    ]
  },
  {
    name: '营销相关',
    icon: 'el-icon-s-marketing',
    children: [
      {
        name: '优惠券',
        pathName: 'marketing-coupon',
        needcan: '优惠券管理'
      },
      {
        name: '优惠券模版',
        pathName: 'marketing-coupon-template',
        needcan: '优惠券管理'
      },
      {
        name: '营销规则',
        pathName: 'marketing-list',
        needcan: '营销规则管理'
      },
      {
        name: '分销设置',
        icon: 'el-icon-share',
        pathName: 'profitsharing',
        needcan: '分销设置'
      },
    ]
  },
  {
    name: '数据分析',
    icon: 'el-icon-s-data',
    needcan: '数据分析',
    children: [
      {
        name: '经营分析',
        pathName: 'statistics-dashboard'
      },
      {
        name: '小程序分析',
        pathName: 'statistics-miniprogram'
      }
    ]
  },
  {
    name: '会员储值',
    icon: 'el-icon-s-finance',
    needcan: '会员储值管理',
    children: [
      {
        name: '储值规则',
        pathName: 'member-storeValueRule'
      },
      {
        name: '储值记录',
        pathName: 'member-storeValueRecords'
      }
    ]
  },
  {
    name: '用户管理',
    icon: 'el-icon-s-custom',
    pathName: 'custom-list',
    needcan: '用户管理'
  },
  {
    name: '配送设置',
    icon: 'el-icon-s-promotion',
    children: [
      {
        name: '配送费',
        pathName: 'setting-shipping',
        needcan: '配送费管理'
      },
      {
        name: '打印员',
        pathName: 'setting-printer',
        needcan: '打印机管理'
      }
    ]
  },
  {
    name: '小程序',
    icon: 'el-icon-s-opportunity',
    children: [
      {
        name: '小程序码',
        pathName: 'setting-minqr',
        needcan: '小程序码管理'
      },
      {
        name: '小程序链接',
        pathName: 'link'
      }
    ]
  },
  {
    name: '设置',
    icon: 'el-icon-s-tools',
    children: [
      {
        name: '店铺信息',
        pathName: 'setting-shopinfo',
        needcan: '店铺信息管理'
      },
      {
        name: '管理员',
        pathName: 'setting-employee',
        needcan: '管理员管理'
      },
      {
        name: '其他配置项',
        pathName: 'setting-options',
        needcan: '店铺信息管理'
      },
    ]
  },
  {
    name: '分店管理',
    icon: 'el-icon-menu',
    pathName: 'branchstore',
    needcan: '分店管理'
  },
];
